// Copyright (c) 2021 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import LaborRateRequestDetails from './labor-rate-request-details';
import ListViewShowMore from '../../../shared/components/list-view-show-more';
import {buildDealer} from '../../../shared/services/build-dealer';

const LaborRateRequestList = props =>
    <div>
        {props.laborRateRequests.length || props.busyCounter ?
            <ul>
                <ListViewShowMore
                    initialShowItems={50}
                    perMoreMultiplier={1.25}
                    showAllOption={true}
                    showPerMore={50}
                    totalItems={props.laborRateRequests.length}
                >
                    {props.laborRateRequests.map((laborRateRequest, index) =>
                        <li
                            className='labor-rate-request-list'
                            key={index}
                        >
                            <div className='labor-rate-request-information-container'>
                                <header>
                                    <div>
                                        {laborRateRequest.requestId}
                                        <span className='list-item-header'>
                                            {buildDealer(laborRateRequest.responsibleAccount, '01')}
                                        </span>
                                    </div>
                                </header>
                                <LaborRateRequestDetails
                                    actions={props.actions}
                                    isEditable={props.isEditable}
                                    key={index}
                                    laborRateRequests={laborRateRequest}
                                />
                            </div>
                        </li>
                    )}
                </ListViewShowMore>
            </ul> :
            <FormattedMessage id='NO_RESULTS_FOUND'/>
        }
    </div>;

LaborRateRequestList.displayName = 'LaborRateRequestList';
LaborRateRequestList.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    isEditable: PropTypes.bool.isRequired,
    laborRateRequests: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired
};

export default LaborRateRequestList;



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/components/labor-rate-request-list.js